import { createSelector } from 'reselect';
import { getHvacAssesmentFormData } from 'src/modules/hvac/selectors/getHvacAssesmentFormData';
import { getHvacCurrencyCode } from 'src/modules/hvac/selectors/getHvacCurrencyCode';
import { HvacFormData } from 'src/modules/hvac/types/HvacFormData';

export const getHvacFormData = createSelector([
  getHvacCurrencyCode,
  getHvacAssesmentFormData,
], (currency, assessment): HvacFormData => ({
  currency,
  assessment,
}));
